import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';

export const Representatives: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const { t } = useTranslation();

  const representatives = tRegion<'imprint.contactsList.representatives.text', { returnObjects: true }, string[]>(
    'imprint.contactsList.representatives.text',
    {
      returnObjects: true,
    },
  );

  return (
    <>
      <h3 className='contacts-list__title'>{t('imprint.contactsList.representatives.title')}</h3>
      <div className='contacts-list__text'>
        {representatives.map((x, i) => (
          <div key={i}>{x}</div>
        ))}
      </div>
    </>
  );
};
